const strings = {
  labels: {
    currentSession: 'Current Session',
  },
} as const;

export default strings;
